// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22_50","controls":"styles_controls__1dbi-","charLimit":"styles_charLimit__JOA6w","input":"styles_input__3JMDV","send":"styles_send__5HNpK"};